module.exports = __webpack_public_path__ + "img/icon_user_qiyechongzi.7817bc3b.png";